var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h1Title"},[_c('div',{staticClass:"h2-tit2"},[_c('span',{staticClass:"cont"},[_vm._v(_vm._s(_vm.title1))])]),_c('div',{staticClass:"h2-tit1"},[_vm._v(_vm._s(_vm.title2))])])}
var staticRenderFns = []

export { render, staticRenderFns }